import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import HistoryRowControls from 'Components/HistoryRowControls';
import HistorySection from 'Components/HistorySection';
import { formatPartialDate } from 'Utility/date';
import { getPatientAgeInMonthsWithOneDecimal } from 'Utility/patientInfo';
import { showPatientAgeInMonthsOnForm } from '../../utils';
import InfoPopover from 'Components/InfoPopover';
import HistoryRowListing from 'Components/HistoryRowListing';
import { Item } from 'Components/Grid';
import DocumentCreationButton from 'Components/DocumentCreationButton';
import { hfmse } from 'neuro-schemas';

const { calculateScore } = hfmse;

const HFMSE = ({ documents, startEdit, view }: IOwnProps): React.JSX.Element => {
  return (
    <HistorySection
      headerText={<FormattedMessage id={'motor.hfmsE'} />}
      newButton={
        <DocumentCreationButton
          name="hfms_e"
          text={'motor.newHFMSE'}
          onClick={startEdit({}, 'hfms_e')}
          width={15}
          height={3}
          fontSize={14}
          alternate={true}
        />
      }
    >
      <HistoryRowListing
        documents={documents}
        headers={
          <>
            <Item xs={2}>
              <FormattedMessage id={'general.date'} />
            </Item>
            <Item xs={6}>
              <FormattedMessage id={'motor.hfmsEScore'} />
            </Item>
          </>
        }
        contentFormat={d => {
          const score = calculateScore(d);
          return (
            <>
              <Item xs={2} id={'hfmseDate'}>
                {showPatientAgeInMonthsOnForm(d.date) ? (
                  <FormattedMessage
                    id="motor.dateAndMonth"
                    values={{
                      date: formatPartialDate(d.date),
                      months: getPatientAgeInMonthsWithOneDecimal(d.date),
                    }}
                  />
                ) : (
                  formatPartialDate(d.date)
                )}
              </Item>
              <Item xs={6} id={'hfmseScore'}>
                {score ?? <InfoPopover text="general.notFilled" color="primary" />}
              </Item>
            </>
          );
        }}
        makeControls
        historyRowControls={d => (
          <div id={'hfmseHistoryControl'}>
            <HistoryRowControls document={d} startEdit={startEdit} view={view} />
          </div>
        )}
      />
    </HistorySection>
  );
};

interface IOwnProps {
  documents: IDocumentWithTypeV2<'hfms_e'>[];
  startEdit: StartEdit;
  view?: IView;
}

export default HFMSE;
